import { Button, Col, Container, Row } from "react-bootstrap";
import userStore from "../../stores/userStore";

import { useStore } from "../../stores/store";
import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import AdminNav from "./adminNav";
import { PagingParams } from "../../models/pagination";


export default  observer(function AllPrompts(){

    const {userStore, adminStore, commonStore} = useStore();
    const {prompts, setPagingParams, pagination} = adminStore;
    const [loadingNext, setLoadingNext] = useState(false);

    useEffect(() => {
        if(commonStore.token){
            userStore.getUser().finally(() => commonStore.setAppLoaded());
        } else{
            commonStore.setAppLoaded()
        }
       
        adminStore.getAllPrompts();
        
    }, [commonStore, userStore, adminStore]);

    if(!commonStore.appLoaded) return <Container><Row> <h1>Loading...</h1></Row></Container>

    function handleGetNext(){
       
        setLoadingNext(true);
       
        setPagingParams(new PagingParams(pagination!.currentPage + 1));
        
        adminStore.getAllPrompts().then(() => setLoadingNext(false));
        
    }


    function handleDelete(id: number){  
        adminStore.deletePrompt(id);
        adminStore.prompts = adminStore.prompts.filter(p => p.id != id);
    }

    return(
        <>
             {userStore.isLoggedIn ? (
                <Container>
                     <Row className='mb-3'>
                            <AdminNav />
                        </Row>
                    <Row>
                            <Col lg={12}><h1>All Prompts</h1></Col>
                    </Row>
                    <Row>
                        <Col lg={2}><h4>Prompt Id</h4></Col>
                        <Col lg={4}><h4>Prompt text</h4></Col>
                        <Col lg={2}><h4>Admin Added</h4></Col>
                        <Col lg={2}><h4>Visible</h4></Col>
                        <Col lg={2}></Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                           
                                {prompts && prompts.map(p => (
                                     <Row className='mt-3'>
                                        <Col lg={2}><span id='promptId'>{p.id}</span></Col>
                                        <Col lg={4}><span>{p.promptText}</span></Col>
                                        <Col lg={2}><span>{p.isAdmin.toString()}</span></Col>
                                        <Col lg={2}><span>{p.isVisible.toString()}</span></Col>
                                        <Col lg={2}><Button onClick={() => handleDelete(p.id)} variant='danger'>Delete</Button></Col>
                                     </Row>
                                ))}
                            
                        </Col>
                    </Row>
                    <Row className='mb-5'>
                                <Col lg={4}>
                                    <Button variant='success' onClick={handleGetNext} disabled={pagination?.currentPage === pagination?.totalPages}>
                                    {loadingNext ? 'Loading...' : "Get Next"}
                                    </Button>
                                </Col>
                                <Col></Col>
                    </Row>
                 </Container>) :
                (
                    <Container><h1>Not logged in</h1></Container>
                )}
        </>
    )
})